module.exports = __webpack_public_path__ + "img/blueTalent.f0f0b42b.svg";